import { ActionTypes, Action, BannerState } from './types';

const INITIAL_STATE: BannerState = {
  hasBanner: false,
};

export default function reducer(state = INITIAL_STATE, action: Action): BannerState {
  switch (action.type) {
    case ActionTypes.SET_HAS_BANNER:
      return {
        hasBanner: action.hasBanner
      };
    default:
      return state;
  }
}
